import { useCallback, useEffect, useState } from 'react';

// Operador activo de Restaurante: quien se identificó con su PIN. Se
// comparte entre Salón, Mesa y Cocina y dura hasta que alguien lo cambia
// a mano o se cierra la pestaña. Cobrar, cancelar y anular siguen pidiendo
// PIN en cada operación.
const CLAVE = 'driza_restaurante_operador';
const EVENTO = 'driza-restaurante-operador';

const leer = () => {
  try {
    const crudo = window.sessionStorage.getItem(CLAVE);
    const dato = crudo ? JSON.parse(crudo) : null;

    return dato?.id ? { id: dato.id, nombre: dato.nombre || '' } : null;
  } catch (_) {
    return null;
  }
};

// Respaldo en memoria por si el navegador no deja usar sessionStorage.
let enMemoria = null;

const actual = () => leer() || enMemoria;

const guardar = (operador) => {
  enMemoria = operador;

  try {
    if (operador) {
      window.sessionStorage.setItem(CLAVE, JSON.stringify(operador));
    } else {
      window.sessionStorage.removeItem(CLAVE);
    }
  } catch (_) {
    // Sin almacenamiento: queda solo en memoria.
  }

  window.dispatchEvent(new Event(EVENTO));
};

export default function useOperadorRestaurante() {
  const [operador, setOperador] = useState(actual);

  useEffect(() => {
    const sincronizar = () => setOperador(actual());

    window.addEventListener(EVENTO, sincronizar);

    return () => window.removeEventListener(EVENTO, sincronizar);
  }, []);

  const identificar = useCallback((usuario) => {
    if (!usuario?.id) return;

    guardar({ id: usuario.id, nombre: usuario.nombre || '' });
  }, []);

  const olvidar = useCallback(() => guardar(null), []);

  return { operador, identificar, olvidar };
}
